module.exports = __webpack_public_path__ + "static/parade-2020-house31-bdd2afa405561c563e8955b69de4fc2f.jpg";